import { Text } from 'platform-components';
import React from 'react';

// @ts-ignore
import StudentsPrintButton from 'common.components/students/__print-button/students__print-button';

interface Props {
    isArchiveClass: boolean;
    descriptionId: string;
    hasStudents: boolean;
    shouldShowPassportAccounts: boolean;
    secondary?: boolean;
    handlePrint: () => void;
}

export const ClassStudentsDescription = ({
    isArchiveClass,
    descriptionId,
    hasStudents,
    shouldShowPassportAccounts,
    handlePrint,
    secondary,
}: Props) => {
    return (
        <div className="class__students-description">
            <span className="class__students-description-text qa_team-students-description">
                <Text id={descriptionId} type={Text.TYPE.HTML} />
            </span>
            {!isArchiveClass && (
                <StudentsPrintButton
                    disabled={!hasStudents}
                    onClick={handlePrint}
                    secondary={secondary}
                    textId={
                        shouldShowPassportAccounts
                            ? 'class.button.addParentsAccessWithPassport'
                            : 'class.button.addParentsAccess'
                    }
                />
            )}
        </div>
    );
};
